import type { SidebarProps } from './sidebar.types';

export const defaultSidebarProps: Required<SidebarProps> = {
	gap: 'spacing-4',
	sideWidth: 'auto',
	minContentWidth: '50%',
	reversed: false,
};
